// src/pages/ContactUsPage.jsx
import React from "react";
import { Link } from "react-router-dom";

const PurchageHistory = () => {

  return (
    <>
      {/* Page Title Section */}
      <div className="wd-page-title page-title page-title-default title-size-default title-design-centered color-scheme-light">
        <div className="container">
          <h1 className="entry-title title">Purchasing History</h1>
          <nav className="wd-breadcrumbs">
            <span typeof="v:Breadcrumb">
              <Link to="/" rel="v:url" property="v:title">
                Home
              </Link>
            </span>
            <span className="wd-delimiter"></span>
            <span className="wd-last">Contact us</span>
          </nav>
        </div>
      </div>

      {/* Main Content Area for Contact Us */}
      <div className="wd-page-content main-page-wrapper">
        <main
          className="wd-content-layout content-layout-wrapper container"
          role="main"
        >
          <div className="wd-content-area site-content">
            <article
              id="post-211"
              className="entry-content post-211 page type-page status-publish hentry"
            >
              <div
                data-elementor-type="wp-page"
                data-elementor-id="211"
                className="elementor elementor-211"
              >
                {/* Profile Section */}
                <section
                  className="wd-negative-gap elementor-section elementor-top-section elementor-element elementor-element-1ebcc4d7 wd-section-stretch-content elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="1ebcc4d7"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-no">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-45af4094"
                      data-id="45af4094"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-76e7b09 elementor-widget elementor-widget-google_maps"
                          data-id="76e7b09"
                          data-element_type="widget"
                          data-widget_type="google_maps.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-custom-embed">
                              <div className="container mt-5">
                                <div
                                  className="card shadow-lg p-4 rounded-4"
                                  style={{ maxWidth: "800px", margin: "auto" }}
                                >
                                  <h3>Not Yet purchased any book...</h3>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </article>
          </div>
        </main>
      </div>
    </>
  );
};

export default PurchageHistory;
